var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeftIcon, ArrowRightIcon } from '@marketing-icons';
import Heading from '@marketing/components/global/typography/Heading';
import { clsx } from 'clsx';
function NavigationLink(_a) {
    var label = _a.label, onClick = _a.onClick, _b = _a.useIcon, useIcon = _b === void 0 ? false : _b, _c = _a.direction, direction = _c === void 0 ? 'right' : _c;
    var ArrowIcon = direction === 'right' ? ArrowRightIcon : ArrowLeftIcon;
    var icon = useIcon ? (_jsx(ArrowIcon, { className: clsx(direction === 'left' ? 'size-7' : 'size-[27px]') })) : null;
    return (_jsxs("a", __assign({ href: "", className: clsx('h-full flex items-center active:text-text-body', direction === 'right' ? 'justify-between' : 'justify-start'), onClick: function (e) {
            e.preventDefault();
            onClick();
            return false;
        } }, { children: [direction === 'left' && useIcon && (_jsx("span", __assign({ className: "inline-block pr-2xs-gutter" }, { children: icon }))), _jsx(Heading, __assign({ className: "!text-lg-nav-m md:!text-lg-nav-m !inline", size: "sm" }, { children: label })), direction === 'right' && useIcon && _jsx("span", __assign({ className: "inline-block" }, { children: icon }))] })));
}
export default NavigationLink;
